module.exports = __webpack_public_path__ + "img/yuanbg.a5827ce1.png";